import { handleResponse } from "../../helpers/handleresponse";
import { authHeader } from "../../helpers/authHeader";
import axios from "axios";
import { checkForUpdates } from "../../meetingEditor/helpers/meetingEditor.helper";
import { defaultModuleSettings } from "../../meetingEditor/models/defaultModuleSettings";

export const meetingService = {
  getUserIp,
  getLayouts,
  getEventId,
  getModules,
  getActiveLayout,
  getPermissions,
};

async function getUserIp() {
  return axios
    .get("./api/meeting/getUserIp")
    .then(({ data }) => {
        return data;
    })
    .catch((error) => {
      console.error(error);
      return "";
    });
}
async function getModules(eventId) {
  return axios
    .get(`./api/meeting/modules/${eventId}`)
    .then(({ data }) => {
      return data.map((r) => {
        let m = r;
        if (r.settings.length > 0 && r.settings != " ") {
          m.settings = JSON.parse(m.settings);
          m.settings = checkForUpdates(m.settings, defaultModuleSettings(m.moduleType));
        }
        return m;
      });
    })
    .catch((err) => {
      console.error(err);
    });
}
async function getPermissions(eventId) {
  return axios
    .get(`./api/meeting/permissions/${eventId}`)
    .then(({ data }) => {
      return data
    })
    .catch((err) => {
      console.error(err);
    });
}
async function getActiveLayout(eventId) {
  return axios
    .get(`./api/meeting/activelayout/${eventId}`)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      console.error(err);
    });
}
async function getLayouts(eventId) {
  return axios
    .get(`./api/meeting/layouts/${eventId}`)
    .then(({ data }) => {
      return data;
    })
    .catch((err) => {
      console.error(err);
    });
}

async function getEventId(eventCode) {
  return axios
    .get(`./api/event/getId/${eventCode}`)
    .then((res) => {
      if ((res.status = 200)) {
        return { eventId: res.data.id, eventName: res.data.name, parentEventId: res.data.parentEventId };
      }
    })
    .catch((err) => {
      if (!err.response || (err.response && err.response.data.message.toLowerCase() === "noevent")) {
        return {
          notAuthorized: true,
          connected: false,
          connecting: false,
        };
      }
      console.error(err);
    });
}
